import { render, staticRenderFns } from "./BlogMain.vue?vue&type=template&id=0faf1ea8&scoped=true"
import script from "./BlogMain.vue?vue&type=script&lang=js"
export * from "./BlogMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf1ea8",
  null
  
)

export default component.exports